import React from 'react';
import GoogleMapReact, { Coords } from 'google-map-react';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Checkbox from '@material-ui/core/Checkbox';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@material-ui/core/FormGroup';
import FormLabel from '@material-ui/core/FormLabel';
import Icon from '@material-ui/core/Icon';
// import Input from '@material-ui/core/Input';
import Link from '@material-ui/core/Link';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Select from '@material-ui/core/Select';
import { withStyles, WithStyles } from '@material-ui/core/styles';
import GetAppIcon from '@material-ui/icons/GetApp';
import { withTranslation, WithTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Link as RouterLink, RouteComponentProps, match } from 'react-router-dom';

// Components
import { ActionLogs } from '../../../components/action-logs';
import { Anchor } from '../../../components/anchor';
import Comment from '../../../components/comment/comment';
import App from '../../../components/app';
// import { ActionCustom, ActionFunction } from '../../../local-types';
import { Dialog, DialogTextColor } from '../../../components/dialog';
// import { AutoFill } from '../../../components/field-autofill';
//
import EnhancedListItem from '../../../components/listItem';
import { FormatType, FormPickerDatas, HeadCell, ListCell, ViewEditCell } from '../../../local-types';
import MainLoading from '../../../components/main-loading';
import MyLink from '../../../components/mylink';
import EnhancedTable from '../../../components/table';
import { TooltipButton } from '../../../components/tooltip-button';
import { Typobold } from '../../../components/typobold';
import FastTabs, { TabsDatas } from '../../../components/tabs/tabs';
import { InlineDocument } from '../../../components/inlineDocument';
import ErrorMessage from '../../../components/error-message';
import FidForm from '../../companies/fid/fid-form';
import FormSubmit from '../../../components/form/formSubmit';
import ViewEditBlock from '../../../components/viewEditBlock';
// Modules
import {
    actions as companyActions,
    CompanyById,
    selectors as companySelectors,
    types as companyTypes,
} from '../../../redux/reducers/companies';
import {
    Airplus,
    Company,
    CompanyCentralizedPayment,
    CompanyCentralizedPaymentMode,
    CompanyMensualCentralizedPaymentMode,
    CompanyNew,
    DispatchGroup,
    DocumentType,
    GroupById,
    GroupNew,
    GroupPaymentPolicy,
    PaymentSettings,
    Sepa,
    TParams,
    TravelPolicyTimeSlot,
} from '../../../redux/reducers/api-types';
import { actions as driversActions, selectors as driversSelectors } from '../../../redux/reducers/drivers';
import { actions as pricingActions, types as pricingTypes } from '../../../redux/reducers/pricing';
import { actions as errorActions, ErrorPayload, selectors as errorSelectors } from '../../../redux/reducers/errors';
import { selectors as pendingSelectors } from '../../../redux/reducers/pendingOperations';
// Ressources
import styles from './contract-view-style';
import FormattingUtils from '../../../utils/formattingUtils';
import withGlobalStyles from '../../../utils/global-styles';
import ObjectUtils from '../../../utils/objectUtils';
import UserUtils, { AccountRight, RightRank } from '../../../utils/userUtils';
import DateUtils from '../../../utils/dateUtils';
import MapUtils from '../../../utils/mapUtils';
import { paths, createPath } from '../../paths';
import { API_ENDPOINT, TableRequestPoint } from '../../../redux/reducers/table';
import {
    editIban,
    generateDocumentUrl,
    getCostCenterDetails,
    getPaymentModeDetails,
    IBAN_REGEX,
    normalizeIban,
} from '../../../utils/businessUtils';
import { EntityName } from '../../../redux/reducers/generic';
import StringUtils from '../../../utils/stringUtils';
import { clsx } from '../../../utils/htmlUtils';
import { Cell, createCell } from '../../../components/table/table-cell-creator';
import envConfig from '../../../config';
import { FEATURE_MULTIGROUP } from '../../../utils/constants';

const queryString = require('query-string');

export const STOP_TYPE_COLOR = {
    all: { label: 'Pickup & Dropoff', strokeColor: '#0000FF', fillColor: '#3244CD' },
    PICKUP: { label: 'Pickup', strokeColor: '#00FF00', fillColor: '#9ACD32' },
    DROP_OFF: { label: 'Dropoff', strokeColor: '#FF0000', fillColor: '#CD3232' },
};

interface CompanyViewPageProps extends WithStyles, WithTranslation, RouteComponentProps {
    match: match<TParams>;
    globalClasses: any;
    center: Coords;
    zoom: number;
    getCompanyError: ErrorPayload;
    contractViewActionsError: ErrorPayload;
    getContractError: ErrorPayload;
    clearError: (errorType: string) => void;
    getIndustriesError: ErrorPayload;
    getTravelPoliciesError: ErrorPayload;
    isLoadingTravelPolicy: boolean;
    getOrEditCompanyGroupPoliciesError: ErrorPayload;
    getOrEditContractGroupPoliciesError: ErrorPayload;
    companies: CompanyById;
    dispatchGroups: DispatchGroup[];
    getCompany: (id: string) => any;
    getCompanyReport: (id: string) => any;
    exportCompanyTrips: (id: string, params?: any) => any;
    exportCompanyUsers: (id: string) => any;
    editMember: (id, idm, payload, type, callback?) => any;
    deleteContract: (id, payload, callback) => any;
    deleteCompany: (id: string, parentId: string) => any;
    banDriverFromCompany: (id, idc, callback) => any;
    unbanDriverFromCompany: (id, idc, blacklistId) => any;
    getTravelPolicies: (uuid, id, parentUuid?) => any;
    getCompanyGroupPolicies: (idGroup: string, uuidContract: string) => any;
    editCompanyGroupPolicies: (uuidContract: string, payload, callback?) => any;
    setContractGroupsAutovalidate: (
        uuidContract: string,
        payload: { skip_member_invitation: boolean },
        callback?,
        onError?,
    ) => any;
    setContractMultigroup: (uuidContract: string, payload: { multigroup_enabled: boolean }, callback?, onError?) => any;
    getDispatchGroups: () => any;
    editCompany: (id, payload) => any;
    editCompanyDispatchGroups: (id, payload, callback) => any;
    getCompanyToExtras: () => any;
    deleteCompanyToExtras: (id, ide) => any;
    getCompanyToPricingSets: () => any;
    createCompanyToExtras: (company, payload, callback) => any;
    deleteCompanyToPricingSets: (id, idp, idc) => any;

    getContractPaymentSettings: (uuidContract: string, callback?) => any;
    setGroupPaymentSettings: (
        uuidContract: string,
        payload: Pick<PaymentSettings, 'group_payment_policies'>,
        callback?,
    ) => any;
    createPaymentMethodSepa: (payload: Sepa, callback?) => any;
    createPaymentMethodAirplus: (payload: Airplus, callback?) => any;

    groups: GroupById;
    getGroup: (id: string) => any;
}

interface CompanyViewPageState {
    text: string;
    idc: any;
    formData: any;
    extra: any;
    myBounds: any;
}

class CompanyViewPage extends React.Component<CompanyViewPageProps, CompanyViewPageState> {
    static defaultProps = {
        center: MapUtils.defaultCenter,
        zoom: MapUtils.defaultZoom,
    };

    map: any;
    maps: any;
    defaultBounds: any;

    autofillRef: any;

    tableMembersRef: any;
    tableContractsRef: any;
    tableDepartmentsRef: any;
    tableRequestPoints: any;

    // LT-881 — the Multigroupe confirmation. The Dialog component opens itself
    // from its own button; `isOpen` only seeds its initial state, so driving it
    // from a prop does not reopen it. `onRef` is the supported handle, and it
    // is what lets the settings block ask for a confirmation at submit time
    // rather than offering a button of its own.
    multigroupDialogRef: { showDialog: (e?) => void; closeDialog: (e?) => void };
    // the settings submit, held until the operator confirms or cancels
    multigroupPending: { confirm: () => void; cancel: () => void } | null = null;

    adminOptions: any[];
    statusOptions: any[];
    contactStatusOptions: any[];
    departmentOptions: any[];

    canWriteSettings: boolean = UserUtils.checkRights({
        name: AccountRight.COMPANY_SETTINGS,
        mode: RightRank.W,
    });

    canExport: boolean = UserUtils.checkRights({
        name: AccountRight.COMPANY_EXPORT,
        mode: RightRank.W,
    });

    canReadPricing: boolean = UserUtils.checkRights({
        name: AccountRight.COMPANY_PRICING,
        mode: RightRank.R,
    });
    canWritePricing: boolean = UserUtils.checkRights({
        name: AccountRight.COMPANY_PRICING,
        mode: RightRank.W,
    });

    canReadFid: boolean = UserUtils.checkRights({
        name: AccountRight.COMPANY_FID_PROGRAM,
        mode: RightRank.R,
    });

    constructor(props: CompanyViewPageProps) {
        super(props);
        this.state = {
            text: '',
            idc: -1,
            formData: {},
            extra: '',
            myBounds: null,
        };
        const { match, t } = this.props;
        const id = match.params.id;
        this.adminOptions = [
            {
                value: '',
                label: '',
            },
            {
                value: 'true',
                label: t('memberships.admin'),
            },
        ];

        this.statusOptions = [
            {
                value: '',
                label: '',
            },
            {
                value: 'confirmed',
                label: t('memberships.status_confirmed'),
            },
            {
                value: 'pending',
                label: t('memberships.status_pending'),
            },
            {
                value: 'ended',
                label: t('memberships.status_ended'),
            },
            {
                value: 'rejected',
                label: t('memberships.status_rejected'),
            },
        ];

        this.contactStatusOptions = [
            {
                value: '',
                label: '',
            },
            {
                value: 'created',
                label: t('document:status.created'),
            },
            {
                value: 'signing',
                label: t('document:status.signing'),
            },
            {
                value: 'pending',
                label: t('document:status.pending'),
            },
            {
                value: 'active',
                label: t('document:status.active'),
            },
            {
                value: 'terminated',
                label: t('document:status.terminated'),
            },
        ];
        this.tableRequestPoints = this.getCurrentTableRequestPoints(id);
    }

    //=======================================//
    //=============== Getters ===============//
    //=======================================//

    get id() {
        const { match } = this.props;
        return match.params.id;
    }

    get company() {
        const { companies } = this.props;
        const id = this.id;
        return companies[id];
    }

    get group() {
        const { groups } = this.props;
        const id = this.id;
        return groups[id];
    }

    get isGroup() {
        const { group: isGroup } = queryString.parse(this.props.location.search);
        return Boolean(isGroup);
    }

    //=========================================//
    //=============== LifeCycle ===============//
    //=========================================//

    componentDidMount() {
        this.load();
    }

    load = (): void => {
        // A failure recorded for the entity we come from would otherwise greet the next
        // one with the retry panel instead of the loader.
        this.props.clearError(companyTypes.GET_CONTRACT);

        const { dispatchGroups } = this.props;
        const company = this.company;
        const group = this.group;
        const isGroup = this.isGroup;

        if ((!isGroup && !company) || (isGroup && !group)) {
            this.loadDatas(this.id);
        }

        if (dispatchGroups.length === 0) {
            this.props.getDispatchGroups();
        }
    };

    static getDerivedStateFromProps(props: CompanyViewPageProps, state) {
        const { match, companies, dispatchGroups, getTravelPolicies } = props;
        const id = match.params.id;
        const payload: any = companies[id];

        if (payload && dispatchGroups.length > 0 && (!state.formData.id || String(state.formData.id) !== id)) {
            // Ride manager
            // getTravelPolicies(payload.uuid, id, payload.parent?.uuid);

            const tmp = [];
            const tmpBo = [];
            // dispatchGroups.forEach((element) => {
            //     const dga = payload.dispatch_group_authorizations.find((d) => d.id === element.id);
            //     tmpBo.push({
            //         name: element.name,
            //         id: element.id,
            //         value: dga ? dga.status_bo : element.defaultAvailable,
            //     });
            //     // Removed for testing => if (!dga || dga.status_bo) {}
            //     tmp.push({
            //         name: element.name,
            //         id: element.id,
            //         value: dga ? dga.status : element.defaultAvailable,
            //     });
            // });

            payload.init = {};
            payload.the_dispatch_groups = tmp;
            payload.init.the_dispatch_groups = ObjectUtils.jsonCopy(tmp);
            payload.the_dispatch_groups_bo = tmpBo;
            payload.init.the_dispatch_groups_bo = ObjectUtils.jsonCopy(tmpBo);
            payload.dispatch_groups = Object.keys(tmp);

            // console.log({ payload });

            return { formData: payload };
        }
        return null;
    }

    componentDidUpdate(prevProps: CompanyViewPageProps, prevState) {
        const id = this.id;
        const prevId = (prevProps.match.params as any).id;

        if (prevId !== id) {
            this.loadDatas(id);
            this.props.getContractPaymentSettings(id);

            this.tableRequestPoints = this.getCurrentTableRequestPoints(id);
        }
        if (prevProps.companies[prevId] !== this.props.companies[id]) {
            const company: any = this.props.companies[id]; //TODO: any should be CompanyNew
            if (company) {
                if (!company?.group_policies && company.company_group) {
                    this.props.getCompanyGroupPolicies(company.company_group, company.id_contract);
                }
            }
        }

        if (prevProps.groups[prevId] !== this.props.groups[id]) {
            const group: GroupNew = this.props.groups[id];
            if (group) {
                if (!group?.group_policies && group.group.id) {
                    this.props.getCompanyGroupPolicies(group.group.id, id);
                }
            }
        }
    }

    //======================================//
    //=============== Method ===============//
    //======================================//

    getCurrentTableRequestPoints(id): { [id: string]: TableRequestPoint } {
        return {
            COMPANIES_DEPARTMENTS: {
                url: `internal/contract/${id}/groups/list`,
                reducer: 'contracts_departments',
                type: API_ENDPOINT.ID,
                query: 'get',
                handleRow: (rowId, row) => `/newCompanies/${row.id}?group=1`,
            },
            COMPANIES_MEMBERSHIPS: {
                url: `internal/contract/${id}/users/list`,
                reducer: 'contracts_memberships',
                type: API_ENDPOINT.ID,
                query: 'get',
                handleRow: (rowId) => `/users/${rowId}`,
            },
            GROUP_MEMBERSHIPS: {
                url: `internal/group/${id}/users/list`,
                reducer: 'groups_memberships',
                type: API_ENDPOINT.ID,
                query: 'get',
                handleRow: (rowId) => `/users/${rowId}`,
            },
            COMPANIES_CONTRACTS: {
                url: `companies/${id}/contracts`,
                reducer: 'contracts_contracts',
            },
        };
    }

    loadDatas(id) {
        // console.log({ isGroup: this.isGroup });
        if (this.isGroup) {
            this.props.getGroup(id);
        } else {
            this.props.getCompany(id);
            this.props.getContractPaymentSettings(id);
        }
    }

    //===================================//
    //=============== MAP ===============//
    //===================================//

    handleApiLoaded = (map, maps): void => {
        this.map = map;
        this.maps = maps;

        const { center } = this.props;
        const company = this.company;

        this.defaultBounds = MapUtils.getBounds(maps, [center]);

        if (company.travel_policies?.areas?.length > 0) {
            const bounds = new maps.LatLngBounds();
            company.travel_policies.areas.forEach((a) => {
                const colors = STOP_TYPE_COLOR[a.stop_type] ?? STOP_TYPE_COLOR.all;
                const newCircle = MapUtils.generateCircle(
                    maps,
                    +a.latitude,
                    +a.longitude,
                    +a.radius,
                    colors.strokeColor,
                    colors.fillColor,
                );
                newCircle.setMap(map);
                MapUtils.extendCircleBounds(maps, bounds, +a.latitude, +a.longitude, +a.radius);
            });
            // map.fitBounds(bounds);
            this.defaultBounds = bounds;
            this.setState({ myBounds: bounds });
        }
    };

    //=============================================//
    //=============== Event Handler ===============//
    //=============================================//

    handleCompaniesRow(id) {
        this.props.history.push(`${paths.companies}/${id}`);
    }

    handleUsersRow(id) {
        this.props.history.push(`${paths.riders}/${id}`);
    }

    handleAction = (obj: any, status: string) => () => {
        const id = this.id;

        if (status === companyTypes.DELETE_COMPANY_CONTRACT) {
            this.props.deleteContract(obj.id, { state: 'terminated' }, () => {
                this.tableContractsRef.reload();
            });
        }
        if (status === pricingTypes.DELETE_COMPANY_PRICING_SET) {
            this.props.deleteCompanyToPricingSets(obj.id, obj.company_to_pricing_set_id, id);
        }
        if (status === pricingTypes.DELETE_COMPANY_EXTRA) {
            this.props.deleteCompanyToExtras(id, obj.company_to_extra_id);
        }
    };

    handleUserUpdate(type, obj, params) {
        if (this.canWriteSettings) {
            const id = this.id; // id company
            const idm = obj.rider.id; // id member
            this.props.editMember(id, idm, params, type);
        }
    }

    handleContractUpdate = (obj, params) => {
        if (this.canWriteSettings) {
            const id = obj.id; // id document

            //deleteContract ne fait que changer le status du contrat
            //We put the value in the actual awaited param
            params.state = params['current_version.state'];
            this.props.deleteContract(id, params, () => {
                this.tableContractsRef.reload();
            });
        }
    };

    handleDeleteCompany(id, parentId) {
        this.props.deleteCompany(id, parentId);
    }

    handleAddExtraSubmit = (event) => {
        event.preventDefault();

        const company = this.company;
        const { extra } = this.state;

        this.props.createCompanyToExtras(company, { extra_id: extra, company_id: company.uuid }, () => {
            this.setState({
                extra: '',
            });
        });
    };

    // Autocomplete
    handleBanDriverFromCompanySubmit = (event) => {
        event.preventDefault();

        const id = this.id;
        const company = this.company;
        const { idc } = this.state;

        //Check if idc (driver id) is set and that it doesn't exist already
        if (idc > 0 && company.banDrivers.findIndex((x) => x.driver?.id === idc) === -1) {
            this.props.banDriverFromCompany(id, idc, () => {
                this.autofillRef.reset();
                this.setState({
                    text: '',
                });
            });
        }
    };

    handleUnbanDriverFromCompany = (idc, idb) => (event) => {
        event.preventDefault();
        if (idb > 0) {
            this.props.unbanDriverFromCompany(this.id, idc, idb);
        }
    };

    handleConfSubmit = (editedDatas: any, fullDatas: any, onSuccess: () => void, onError: () => void) => {
        const id = this.id;

        // const payload = {
        //     reservation_sms: !editedDatas.sms.length > 0,
        // };
        // this.props.editCompany(id, payload);

        const payload = {
            groups: [this.isGroup ? this.group.group.id : (this.company as any).company_group],
            recurring_enable: editedDatas.recurrence,
            ...(this.isGroup && { skip_member_invitation: editedDatas.autovalidate }),
        };

        // console.log({ payload, editedDatas, fullDatas });
        const savePolicies = () =>
            this.props.editCompanyGroupPolicies(id, payload, () => {
                onSuccess();
            });

        // A contract stores autovalidate on its own endpoint: save the policies only once it went through,
        // otherwise the block reports success while the autovalidate change was refused.
        const saveAutovalidateThenPolicies = () => {
            // Only when the cell was touched: marshall writes the value onto every group of the
            // contract, so resending an untouched one overwrites each department's own setting.
            if (!this.isGroup && editedDatas.autovalidate !== undefined) {
                this.props.setContractGroupsAutovalidate(
                    id,
                    { skip_member_invitation: editedDatas.autovalidate },
                    savePolicies,
                    onError,
                );
            } else {
                savePolicies();
            }
        };

        // LT-881 — Multigroupe is confirmed before anything is sent, because
        // activating it cannot be undone from here: id refuses the on -> off
        // transition until LT-1941 ships the controlled deactivation. The cell
        // is readOnly once on and `editedDatas` carries only the cells the
        // operator touched, so `true` here is always a fresh activation.
        //
        // It goes first and the rest waits on it, for the reason the comment
        // above gives about autovalidate: a block reporting success over a
        // refused change is worse than a failure.
        if (!this.isGroup && editedDatas.multigroup === true) {
            this.multigroupPending = {
                confirm: () =>
                    this.props.setContractMultigroup(
                        id,
                        { multigroup_enabled: true },
                        saveAutovalidateThenPolicies,
                        onError,
                    ),
                // Cancelling is not a no-op for the block: onError is what puts
                // the row back to the value still in force and keeps editing
                // open, so the checkbox does not stay ticked over a contract
                // that was never flagged.
                cancel: onError,
            };
            this.multigroupDialogRef?.showDialog();
            return;
        }

        saveAutovalidateThenPolicies();
    };

    handleMultigroupConfirm = () => {
        const pending = this.multigroupPending;
        this.multigroupPending = null;
        pending?.confirm();
    };

    handleMultigroupCancel = () => {
        const pending = this.multigroupPending;
        this.multigroupPending = null;
        pending?.cancel();
    };

    handlePaymentSubmit =
        (group: GroupPaymentPolicy) =>
        (editedDatas: any, fullDatas: any, onSuccess: () => void, onError: () => void) => {
            const id = this.id;
            const groupId = group.group_id;
            const { createPaymentMethodSepa, createPaymentMethodAirplus, setGroupPaymentSettings } = this.props;

            console.log({ editedDatas, fullDatas });

            let creationMethod: Function = null;
            let creationPayload: Sepa | Airplus = null;
            if (Object.keys(editedDatas).some((k) => k.startsWith('sepa'))) {
                console.log('sepa to create');
                creationMethod = createPaymentMethodSepa;
                creationPayload = {
                    holder_id: groupId,
                    name: editedDatas['sepa[name]'],
                    iban: normalizeIban(editedDatas['sepa[iban]']),
                    rum: editedDatas['sepa[rum]'],
                    signature_date: editedDatas['sepa[contract_signing_date]'],
                };
                console.log('sepa to create');
            } else if (Object.keys(editedDatas).some((k) => k.startsWith('airplus'))) {
                console.log('airplus to create');
                creationMethod = createPaymentMethodAirplus;
                creationPayload = {
                    holder_id: groupId,
                    card_number: editedDatas['airplus[card_number]'],
                    expiry_date: editedDatas['airplus[expiry_date]'] + '-01',
                };
            }

            const payload: Pick<PaymentSettings, 'group_payment_policies'> = {
                group_payment_policies: [
                    {
                        group_id: groupId,
                        payment_mode: editedDatas.centralized_payment,
                        payment_frequency: editedDatas.centralized_payment_mode,
                        default_payment_method: editedDatas.centralized_mensual_payment_mode
                            ? {
                                  id: editedDatas.centralized_mensual_payment_mode,
                              }
                            : undefined,
                    },
                ],
            };

            console.log({ payload, creationPayload });
            const updateSettings = (_?, response?: any) => {
                const newId = response?.payload?.data?.id;
                if (newId) {
                    payload.group_payment_policies[0].default_payment_method.id = newId;
                }
                this.props.setGroupPaymentSettings(id, payload, onSuccess);
            };

            if (creationMethod) {
                creationMethod(creationPayload, updateSettings);
            } else {
                updateSettings();
            }
        };

    handleSubmit = (event) => {
        event.preventDefault();
        const { formData } = this.state;
        const { the_dispatch_groups, the_dispatch_groups_bo } = formData;
        const id = this.id;

        const payload_groups = [];
        the_dispatch_groups_bo.forEach((element) => {
            const dga = the_dispatch_groups.find((d) => d.id === element.id);
            if (element.value) {
                payload_groups.push({
                    name: element.name,
                    id: element.id,
                    value: dga.value,
                });
            }
        });

        this.props.editCompanyDispatchGroups(
            id,
            {
                the_dispatch_groups: payload_groups,
                the_dispatch_groups_bo,
            },
            () => {
                formData.the_dispatch_groups = payload_groups;
                formData.init.the_dispatch_groups = payload_groups;
                formData.init.the_dispatch_groups_bo = ObjectUtils.jsonCopy(the_dispatch_groups_bo);
                this.setState({ formData });
            },
        );
    };

    loaderObserver(flags, row, id) {
        if (flags.companies?.[row.company.id]?.riders?.[row.rider.id]?.loader?.[id]?.loading) {
            return <MainLoading center size={24} />;
        }
        return null;
    }

    headerDepartmentBuilder = (): HeadCell[] => {
        const { t } = this.props;
        const headers: HeadCell[] = [
            // createCell(t, Cell.ID, { sortable: true }),
            createCell(t, Cell.NAME),
            createCell(t, Cell.CREATION_DATE, { sortable: true }),
            { id: 'n_users', label: t('nb_users'), filterable: false, sortable: true },
        ];
        return headers;
    };

    headerMembershipBuilder = (payload: Company): HeadCell[] => {
        const { t } = this.props;

        this.departmentOptions = [{ value: '', label: '' }];
        if (payload.departments) {
            payload.departments.forEach((d) => {
                this.departmentOptions.push({
                    value: d.id,
                    label: `${d.name}${d.deletion_date ? ` (${t('common:suspended')})` : ''} (${d.id})`,
                });
            });
        }

        const headers: HeadCell[] = [
            createCell(t, Cell.ID, { sortable: true }),
            {
                id: 'fullname',
                label: t('common:form.lastname'),
                formatCell: (row) => {
                    return StringUtils.userFullname(row);
                },
            },
            createCell(t, Cell.EMAIL),
            {
                id: 'phone_e164',
                idSearch: 'phone_number',
                idSort: 'phone_number',
                label: t('common:form.phone_number'),
                type: FormatType.Phone,
            },
            // {
            //     id: 'status',
            //     label: t('memberships.status'),
            //     type: FormatType.Picker,
            //     disabled: !this.canWriteSettings,
            //     action: this.handleUserUpdate.bind(this, 'status'),
            //     pickerOptions: this.statusOptions,
            //     loaderCell: null /*(row, id) => this.loaderObserver(flags, row, id),*/,
            // },
            {
                id: 'contract_principal',
                label: t('memberships.admin'),
                type: FormatType.Picker,
                // disabled: !this.canWriteSettings,
                // action: this.handleUserUpdate.bind(this, 'admin'),
                formatCell: (row) => {
                    const roles = Array.isArray(row?.roles) ? row?.roles : row?.roles?.split(',');
                    return roles?.includes('PRINCIPAL') ? t('common:true') : t('common:false');
                },
                pickerOptions: this.adminOptions,
                loaderCell: null /*(row, id) => this.loaderObserver(flags, row, id),*/,
            },
            // {
            //     id: 'accountant',
            //     label: t('memberships.accountant'),
            //     type: FormatType.Boolean,
            //     disabled: !this.canWriteSettings,
            //     action: this.handleUserUpdate.bind(this, 'accountant'),
            //     loaderCell: null /* (row, id) => this.loaderObserver(flags, row, id),*/,
            // },
        ];

        // Add department column only when no parents
        if (!payload.parent) {
            // headers.push({
            //     id: 'department.id',
            //     label: t('memberships.department'),
            //     type: FormatType.Picker,
            //     disabled: !this.canWriteSettings,
            //     action: this.handleUserUpdate.bind(this, 'department_id'),
            //     pickerOptions: this.departmentOptions,
            //     loaderCell: null /*(row, id) => this.loaderObserver(flags, row, id),*/,
            // });
            // headers.push({
            //     id: 'group_name',
            //     label: t('memberships.department'),
            // });
        }
        return headers;
    };

    headerContractBuilder = (): HeadCell[] => {
        const { t, globalClasses } = this.props;
        const id = this.id;

        const headers: HeadCell[] = [
            createCell(t, Cell.ID, { filterable: false }),
            createCell(t, Cell.CREATION_DATE),
            {
                id: 'current_version.state',
                label: t('memberships.status'),
                filterable: false,
                type: FormatType.Picker,
                disabled: !this.canWriteSettings,
                action: this.handleContractUpdate,
                pickerOptions: this.contactStatusOptions,
            },
            {
                id: 'current_version.start_date',
                label: t('contracts.start_date'),
                type: FormatType.DateShort,
                filterable: false,
            },
            {
                id: 'current_version.end_date',
                label: t('contracts.end_date'),
                type: FormatType.DateShort,
                filterable: false,
            },
            {
                id: 'status',
                label: t('contracts.file'),
                filterable: false,
                formatCell: (row) => {
                    const { current_version } = row;
                    return (
                        <TooltipButton title={t('common:download')}>
                            <Button
                                size="small"
                                variant="contained"
                                color="secondary"
                                href={generateDocumentUrl(current_version.id)}
                                target="_blank"
                                rel="noreferrer noopener"
                                style={{ minWidth: 'auto', paddingLeft: 4, paddingRight: 4 }}
                                className={globalClasses.btnAutoWidth}
                            >
                                <GetAppIcon />
                            </Button>
                        </TooltipButton>
                    );
                },
            },
        ];

        if (this.canWriteSettings) {
            headers.push({
                id: 'action',
                label: t('common:action'),
                filterable: false,
                formatCell: (row) => {
                    return (
                        <div>
                            <TooltipButton title={t('common:edit')}>
                                <Button
                                    size="small"
                                    variant="contained"
                                    color="primary"
                                    style={{ marginRight: 8 }}
                                    component={RouterLink}
                                    to={createPath(paths.companiesContractEdit, { id, idc: row.current_version.id })}
                                    className={clsx(globalClasses.btnAutoWidth, globalClasses.btnEdit)}
                                >
                                    <Icon fontSize="small">edit</Icon>
                                </Button>
                            </TooltipButton>
                            <Dialog
                                btnTitle={t('common:validate')}
                                description={t('common:deleteParam', { id: row.id })}
                                customButton={
                                    <TooltipButton title={t('common:delete')}>
                                        <Button
                                            size="small"
                                            variant="contained"
                                            color="primary"
                                            className={clsx(globalClasses.btnAutoWidth, globalClasses.btnDanger)}
                                        >
                                            <Icon fontSize="small">close</Icon>
                                        </Button>
                                    </TooltipButton>
                                }
                                onOK={this.handleAction(row, companyTypes.DELETE_COMPANY_CONTRACT)}
                            />
                        </div>
                    );
                },
            });
        }

        return headers;
    };

    renderCourseTypeView = (): JSX.Element[] => {
        const { formData } = this.state;
        if (formData?.the_dispatch_groups) {
            return formData.the_dispatch_groups.map(
                (item, key) =>
                    formData.the_dispatch_groups_bo.find((g) => g.id === item.id).value && (
                        <FormControlLabel
                            key={`${item.id}-${key}`}
                            style={{ marginLeft: 8 }}
                            disabled={!this.canWriteSettings}
                            control={
                                <Checkbox
                                    checked={
                                        formData.the_dispatch_groups.findIndex(
                                            (g) => g.id === item.id && g.value === true,
                                        ) !== -1
                                    }
                                    value={item.id}
                                    onChange={() => {
                                        const dgbo = formData.the_dispatch_groups.find((g) => g.id === item.id);
                                        dgbo.value = !dgbo.value;
                                        this.setState({
                                            formData,
                                        });
                                    }}
                                />
                            }
                            label={item.name}
                        />
                    ),
            );
        }
        return null;
    };

    //TODO: quand on réactive il faudrait rajouter les nouveaux
    renderCourseTypeBoView = (): JSX.Element[] => {
        const { formData } = this.state;
        if (formData?.the_dispatch_groups_bo) {
            return formData.the_dispatch_groups_bo.map((item, key) => (
                <FormControlLabel
                    key={`${item.id}-${key}`}
                    style={{ marginLeft: 8 }}
                    control={
                        <Checkbox
                            checked={
                                formData.the_dispatch_groups_bo.findIndex(
                                    (g) => g.id === item.id && g.value === true,
                                ) !== -1
                            }
                            value={item.id}
                            onChange={() => {
                                const dgbo = formData.the_dispatch_groups_bo.find((g) => g.id === item.id);
                                dgbo.value = !dgbo.value;
                                this.setState({
                                    formData,
                                });
                            }}
                        />
                    }
                    label={item.name}
                />
            ));
        }
        return null;
    };

    listItemBuilder = (payload: CompanyNew | GroupNew): ListCell[] => {
        const { t } = this.props;
        let items: ListCell[] = [];
        if (this.isGroup && 'group' in payload && payload.group) {
            items = [
                { title: t('group_id'), data: payload.group.id, readOnly: true },
                { title: t('common:form.lastname'), data: payload.group.name },
                {
                    title: t('parent'),
                    data: (
                        <Link color="secondary" component={RouterLink} to={`${paths.contracts}/${payload.company.id}`}>
                            {`${payload.company.name}`}
                        </Link>
                    ),
                    readOnly: true,
                },
                {
                    title: t('creation_date'),
                    readOnly: true,
                    data: payload.group.created_at,
                    type: FormatType.DateShort,
                },
            ];
        } else if ('id_contract' in payload && payload) {
            // Nom de l’entreprise (name)
            // UUID groupe Entreprise (company_group)
            // UUID Contrat (id_contract)
            // SIREN (à voir quand dispo) (siren)
            // Date de création (created_at)
            // Date de signature (signed_at)
            // Type de contrat Signé (Corporate, Club Basic, Club Prio, Club Premium) (plan_name)
            // Nombre d’utilisateur (n_user)

            items = [
                { title: t('id_contract'), data: payload.id_contract, readOnly: true },
                { title: t('common:form.lastname'), data: payload.name },
                { title: t('company_group'), data: payload.company_group, readOnly: true },
                { title: t('siren'), data: payload.siren },
                {
                    title: t('creation_date'),
                    readOnly: true,
                    data: payload.created_at,
                    type: FormatType.DateShort,
                },
                {
                    title: t('signed_at'),
                    readOnly: true,
                    data: payload.signed_at,
                    type: FormatType.DateShort,
                },
                // {
                //     title: t('activation_date'),
                //     data: payload.activation_date,
                //     optional: true,
                //     type: FormatType.DateShort,
                // },

                { title: t('plan_type'), data: payload.plan_name },
                // {
                //     title: t('parent'),
                //     readOnly: true,
                //     data: payload.parent && (
                //         <Link
                //             color="secondary"
                //             component={RouterLink}
                //             to={createPath(paths.companiesDetails, { id: payload.parent.id })}
                //         >
                //             {payload.parent.name}
                //         </Link>
                //     ),
                //     optional: true,
                // },
                { title: t('nb_users'), readOnly: true, data: payload.n_user },
                // {
                //     title: t('nb_bookings'),
                //     readOnly: true,
                //     data:
                //         payload.nb_bookings > 0 ? (
                //             <MyLink color="secondary" to={`${paths.bookings}?filters[company.id]=${payload.id}`}>{`${
                //                 payload.nb_bookings
                //             } (${t('common:click_to_see')})`}</MyLink>
                //         ) : (
                //             payload.nb_bookings
                //         ),
                //     optional: true,
                // },
                {
                    title: t('account_manager'),
                    readOnly: false,
                    optional: true,
                    data: payload.account_manager && (
                        <Link
                            color="secondary"
                            component={RouterLink}
                            to={`${paths.users}/${payload.account_manager.uuid}`}
                        >
                            {StringUtils.userFullname(payload.account_manager)}
                        </Link>
                    ),
                },
                {
                    title: t('industry'),
                    readOnly: false,
                    optional: true,
                    data: payload.industry?.name,
                },
                // {
                //     title: '',
                //     data: '',
                //     emptyCell: true,
                // },
                {
                    title: t('simple_invoice'),
                    readOnly: true,
                    data: (
                        <Link
                            color="secondary"
                            component={RouterLink}
                            to={`${paths.billsSimple}?filters[company_id]=${payload.company_group}`}
                        >
                            {t('common:click_to_see')}
                        </Link>
                    ),
                },
                {
                    title: t('mensual_invoice'),
                    readOnly: true,
                    data: (
                        <Link
                            color="secondary"
                            component={RouterLink}
                            to={`${paths.billsPeriods}?filters[company_id]=${payload.company_group}`}
                        >
                            {t('common:click_to_see')}
                        </Link>
                    ),
                },
                {
                    title: t('refound'),
                    readOnly: true,
                    data: (
                        <Link
                            color="secondary"
                            component={RouterLink}
                            to={`${paths.billsCreditNotes}?filters[company_id]=${payload.company_group}`}
                        >
                            {t('common:click_to_see')}
                        </Link>
                    ),
                },
                {
                    title: t('refound_month'),
                    readOnly: true,
                    data: (
                        <Link
                            color="secondary"
                            component={RouterLink}
                            to={`${paths.billsMonthCreditNotes}?filters[company_id]=${payload.company_group}`}
                        >
                            {t('common:click_to_see')}
                        </Link>
                    ),
                },
            ];
        }
        return items;
    };

    listItemBillingBuilder = (payload: Company): ListCell[] => {
        const { t } = this.props;

        return [
            {
                title: t('corporate_name'),
                data: payload.corporate_name,
                optional: true,
            },
            {
                title: t('contract_number'),
                data: payload.contract_number,
                optional: true,
            },
            { title: t('purchase_order'), data: payload.purchase_order },
            { title: t('vat_number'), data: payload.vat_number },
            {
                title: t('billing_address'),
                data: payload.billing_address,
                type: FormatType.Address,
            },
            {
                title: t('billing_cost_center'),
                data: payload.recipient_type === 'cost_center',
                type: FormatType.Boolean,
            },
            {
                title: t('accountants'),
                data: (
                    <div
                        style={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            flexDirection: 'column',
                        }}
                    >
                        {payload.accountants?.map((a, index) => {
                            return (
                                <div key={`${a.id}-${index}`}>
                                    <Link
                                        color="secondary"
                                        key={a.id}
                                        component={RouterLink}
                                        to={createPath(paths.ridersDetails, { id: a.id })}
                                    >
                                        {StringUtils.userFullname(a as any)}
                                    </Link>
                                    <span>
                                        {' '}
                                        ({a.email} - {a.phone_number})
                                    </span>
                                </div>
                            );
                        })}

                        {payload.billing_emails &&
                            payload.billing_emails.length > 0 &&
                            payload.billing_emails.split(';').map((mail, index) => {
                                return (
                                    <div key={`${mail}-${index}`}>
                                        <span>{mail}</span>
                                    </div>
                                );
                            })}
                    </div>
                ),
                optional: true,
            },
            {
                title: t('send_bill_export'),
                data: payload.send_bill_export,
                type: FormatType.Boolean,
            },
        ];
    };

    listItemFacturationBuilder = (payload: Company): ListCell[] => {
        const { t, globalClasses } = this.props;

        const items: ListCell[] = [
            {
                title: t('pricing_sets'),
                data: (
                    <div>
                        <div
                            style={{
                                display: 'flex',
                                flexWrap: 'wrap',
                                flexDirection: 'column',
                            }}
                        >
                            {this.canWritePricing && (
                                <TooltipButton title={t('common:add')}>
                                    <Button
                                        size="small"
                                        variant="contained"
                                        color="secondary"
                                        component={RouterLink}
                                        to={paths.pricingManagePrices}
                                        className={globalClasses.btnAutoWidth}
                                    >
                                        <Icon fontSize="small">add</Icon>
                                    </Button>
                                </TooltipButton>
                            )}

                            {payload.pricing_sets?.map((o, oid) => {
                                return (
                                    <div key={`${oid}-${o.id}`} style={{ margin: '8px 0px' }}>
                                        <span style={{ marginRight: 8 }}>{`${o.service?.name}: ${o.name}`}</span>
                                        {this.canWritePricing && (
                                            <TooltipButton title={t('common:edit')}>
                                                <Button
                                                    size="small"
                                                    variant="contained"
                                                    color="primary"
                                                    style={{ marginRight: 8 }}
                                                    component={RouterLink}
                                                    to={createPath(paths.pricingManagePricesDetails, { id: o.id })}
                                                    className={globalClasses.btnAutoWidth}
                                                >
                                                    <Icon fontSize="small">edit</Icon>
                                                </Button>
                                            </TooltipButton>
                                        )}
                                        {/* <Dialog
                                                btnTitle={t('common:validate')}
                                                description={t('common:deleteParam', { id: o.id })}
                                                customButton={
                                                    <TooltipButton title={t('common:delete')}>
                                                        <Button
                                                            size="small"
                                                            variant="contained"
                                                            color="primary"
                                                            className={clsx(globalClasses.btnAutoWidth, globalClasses.btnDanger)}
                                                        >
                                                            <Icon fontSize="small">delete</Icon>
                                                        </Button>
                                                    </TooltipButton>
                                                }
                                                onOK={this.handleAction(o, pricingTypes.DELETE_COMPANY_PRICING_SET)}
                                            /> */}
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                ),
                optional: true,
            },
            {
                title: t('management_fee'),
                data: payload.extras_list && (
                    <div
                        style={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            flexDirection: 'column',
                        }}
                    >
                        {this.canWritePricing && (
                            <FormSubmit debounceSubmit={{ callback: this.handleAddExtraSubmit }}>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <FormControl key={'formExtras'} margin="dense">
                                        <Select
                                            native
                                            id={'extra'}
                                            name={'extra'}
                                            value={this.state.extra}
                                            required={true}
                                            onChange={(e) => {
                                                this.setState({
                                                    extra: e.target.value,
                                                });
                                            }}
                                        >
                                            <option key={'empty'} value={''}>
                                                {''}
                                            </option>
                                            {payload.extras_list
                                                .filter((e) => !payload.management_fee.find((x) => x.id === e.id))
                                                .map((select, i) => {
                                                    return (
                                                        <option key={`${select.id}-${i}`} value={select.id}>
                                                            {select.name}
                                                        </option>
                                                    );
                                                })}
                                        </Select>
                                    </FormControl>
                                    <span>
                                        <TooltipButton title={t('common:add')}>
                                            <Button
                                                size="small"
                                                type="submit"
                                                variant="contained"
                                                color="secondary"
                                                className={globalClasses.btnAutoWidth}
                                            >
                                                <Icon fontSize="small">add</Icon>
                                            </Button>
                                        </TooltipButton>
                                    </span>
                                </div>
                            </FormSubmit>
                        )}

                        {payload.management_fee?.map((mf, i) => {
                            return (
                                <div key={`${mf.id}-${i}`} style={{ margin: '8px 0px' }}>
                                    <span style={{ marginRight: 8 }}>{mf.name}</span>

                                    {this.canWritePricing && (
                                        <Dialog
                                            btnTitle={t('common:validate')}
                                            description={t('common:deleteParam', { id: mf.id })}
                                            customButton={
                                                <TooltipButton title={t('common:delete')}>
                                                    <Button
                                                        size="small"
                                                        variant="contained"
                                                        color="primary"
                                                        className={clsx(
                                                            globalClasses.btnAutoWidth,
                                                            globalClasses.btnDanger,
                                                        )}
                                                    >
                                                        <Icon fontSize="small">delete</Icon>
                                                    </Button>
                                                </TooltipButton>
                                            }
                                            onOK={this.handleAction(mf, pricingTypes.DELETE_COMPANY_EXTRA)}
                                        />
                                    )}
                                </div>
                            );
                        })}
                    </div>
                ),
                optional: true,
            },
            // List of the billing_month_payments in the company + active or not
            // {
            //     title: t('centralized_payment_mode_details'),
            //     data:
            //         payload.centralized_payment === CompanyCentralizedPayment.central
            //             ? payload.billing_month_payments.map(
            //                   (bmp) => `${t('paiement.type.' + bmp.type)} - ${bmp.name} (${bmp.status})`,
            //               )
            //             : 'N/A',
            // },
        ];
        return items;
    };

    listItemPaiementBuilder = (payload: Company): ListCell[] => {
        const { t } = this.props;

        const defaultPayment = payload.default_billing_month_payments;
        const is_sepa: boolean =
            payload.centralized_payment_mode === CompanyCentralizedPaymentMode.mensual &&
            payload.centralized_mensual_payment_mode === CompanyMensualCentralizedPaymentMode.sepa;

        const { centralizedPaymentMode, centralizedMensualPaymentMode } = getPaymentModeDetails(payload, t);

        let items: ListCell[] = [
            {
                title: t('grouped_payment_allowed'),
                data: payload.grouped_payment_allowed,
                type: FormatType.Boolean,
            },
            {
                title: t('payment_policy'),
                data:
                    payload.centralized_payment === CompanyCentralizedPayment.central
                        ? t('paiement.central')
                        : t('paiement.individual'),
            },
            {
                title: t('centralized_payment_mode'),
                data: centralizedPaymentMode,
            },
            {
                title: t('centralized_mensual_payment_mode'),
                data: centralizedMensualPaymentMode,
            },
            {
                title: t('paiement.type.sepa'),
                data:
                    is_sepa &&
                    `${defaultPayment.sepa_holder_name}\n${FormattingUtils.format(
                        defaultPayment.sepa_signature_date,
                        FormatType.DateShort,
                        t,
                    )}\n${defaultPayment.sepa_iban}\n${defaultPayment.sepa_rum}`,
            },
            {
                title: t('common:docs.rib'),
                data: true,
                customValue: (
                    <InlineDocument
                        key={'vtc_license'}
                        {...this.generateDocuments(payload).find((d) => d.docType === 'rib')}
                        docClass="company"
                        classId={payload.id}
                        readOnly={!this.canWriteSettings}
                        noLabel={true}
                    />
                ),
            },
            {
                title: t('obp_webapp'),
                data: payload.obp_webapp,
                type: FormatType.Boolean,
            },
        ];

        if (!is_sepa) {
            items = items.filter((i) => i.title !== t('paiement.type.sepa'));
        }
        return items;
    };

    listItemTripBuilder = (payload: Company): ListCell[] => {
        const { t } = this.props;

        return [
            {
                title: t('book_for_others'),
                data: payload.book_for_others,
                type: FormatType.Boolean,
            },
            {
                title: t('default_booking_address'),
                data: payload.default_booking_address,
                type: FormatType.Address,
                optional: true,
            },
            {
                title: t('default_cost_center'),
                data: getCostCenterDetails(payload.default_cost_center),
                optional: true,
            },
            {
                title: t('cost_center_mandatory'),
                data: payload.cost_center_mandatory,
                type: FormatType.Boolean,
            },
            {
                title: t('ride_reason_mandatory'),
                data: payload.ride_reason_mandatory,
                type: FormatType.Boolean,
            },
            {
                title: t('analytics_reference_enabled'),
                data: payload.analytics_reference_enabled,
                type: FormatType.Boolean,
            },
        ];
    };

    listItemRestrictionsBuilder = (payload: Company): ListCell[] => {
        const { t, zoom, center } = this.props;

        const sortingDaysArr = DateUtils.sortingDaysArr;

        if (!payload.travel_policies) {
            return [];
        }
        return [
            {
                title: t('trip_policy_restrictions.hours'),
                data:
                    payload.travel_policies?.time_slots &&
                    Object.entries(payload.travel_policies.time_slots)
                        .sort((a, b) => sortingDaysArr.indexOf(a[0]) - sortingDaysArr.indexOf(b[0]))
                        .map(([day, slots]: [string, Array<TravelPolicyTimeSlot>]) => {
                            return (
                                t('common:days.' + day) +
                                ': ' +
                                slots
                                    .map((s) => `${t('common:from')} ${s.start} ${t('common:hour_to')} ${s.end}`)
                                    .join(', ')
                            );
                        })
                        .join('\n'),
            },
            {
                title: t('trip_policy_restrictions.location'),
                optional: true,
                data:
                    payload.travel_policies?.areas &&
                    payload.travel_policies.areas
                        .map((a) => `${a.latitude} ${a.longitude} - radius ${a.radius}`)
                        .join('\n'),
                customValue: (
                    <>
                        <div style={{ display: 'flex', justifyContent: 'end' }}>
                            {Object.entries(STOP_TYPE_COLOR).map((k, index) => {
                                return (
                                    <div
                                        key={`${index}-${k[1].label}`}
                                        style={{ display: 'flex', alignItems: 'center', marginRight: 8 }}
                                    >
                                        <span
                                            style={{
                                                height: 10,
                                                width: 10,
                                                backgroundColor: k[1].fillColor,
                                                marginRight: 8,
                                            }}
                                        />
                                        {k[1].label}
                                    </div>
                                );
                            })}
                        </div>
                        <div style={{ height: '50vh', width: '100%' }}>
                            <GoogleMapReact
                                key={payload.uuid}
                                bootstrapURLKeys={{ key: envConfig.google_key }}
                                yesIWantToUseGoogleMapApiInternals
                                onGoogleApiLoaded={({ map, maps }) => this.handleApiLoaded(map, maps)}
                                defaultCenter={center}
                                defaultZoom={zoom}
                            />
                        </div>
                    </>
                ),
            },
        ];
    };

    generateDocuments = (payload: Company): DocumentType[] => {
        const { t } = this.props;

        const documents: DocumentType[] = [
            {
                id: payload.documents?.rib,
                name: t('common:docs.rib'),
                docType: 'rib',
            },
        ];
        return documents;
    };

    renderAdminDocuments = (payload: Company): JSX.Element => {
        const { t, classes } = this.props;
        if (payload && this.canWriteSettings) {
            const documents: DocumentType[] = this.generateDocuments(payload);
            return (
                <>
                    <br />
                    <Anchor id="documents" />
                    <Typobold>{t('common:form.documents')}</Typobold>
                    <div className={classes.docsCtn}>
                        {documents.map((doc) => (
                            <InlineDocument
                                key={doc.docType}
                                {...doc}
                                docClass="company"
                                readOnly={!this.canWriteSettings}
                                classId={payload.id}
                            />
                        ))}
                    </div>
                    <br />
                </>
            );
        }
        return null;
    };

    getActions = (id: string): any[] => {
        const { t } = this.props;
        const actions: any[] = [];
        if (this.canExport) {
            // actions.push({
            //     label: t('actions.export_all_users'),
            //     func: () => this.props.exportCompanyUsers(id),
            // });
            // actions.push({
            //     label: t('actions.export_all_trips'),
            //     func: () => this.props.exportCompanyTrips(id),
            // });
            // actions.push({
            //     label: t('actions.export_trips'),
            //     customView: (
            //         <Dialog
            //             btnTitle={t('actions.export_trips')}
            //             description={t('actions.export_trips_description')}
            //             customButton={<div>{t('actions.export_trips')}</div>}
            //             formComponent={
            //                 <>
            //                     <FormControl key={'formStartDate'} style={{ display: 'flex' }}>
            //                         <div>{`${t('common:form.start_date')} *`}</div>
            //                         <Input type="date" name={'start_date'} required={true} />
            //                     </FormControl>
            //                     <FormControl key={'formEndDate'} style={{ display: 'flex' }}>
            //                         <div>{t('common:form.end_date')}</div>
            //                         <Input type="date" name={'end_date'} />
            //                     </FormControl>
            //                 </>
            //             }
            //             onOK={(fields) => {
            //                 let params = {
            //                     'filters[0][parameter]': 'creation_date',
            //                     'filters[0][type]': 'greater_than',
            //                     'filters[0][option][]': 'is_date',
            //                     'filters[0][value]': new Date(fields.start_date).getTime() / 1000,
            //                 };
            //                 if (fields.end_date) {
            //                     Object.assign(params, {
            //                         'filters[1][parameter]': 'creation_date',
            //                         'filters[1][type]': 'lower_or_equal_than',
            //                         'filters[1][option][]': 'is_date',
            //                         'filters[1][value]': new Date(fields.end_date).getTime() / 1000,
            //                     });
            //                 }
            //                 this.props.exportCompanyTrips(id, params);
            //             }}
            //         />
            //     ),
            // });
            actions.push({
                label: t('actions.export_report'),
                func: () => this.props.getCompanyReport(id),
            });
        }
        return actions;
    };

    renderEditButton = (id: string) => {
        const { t } = this.props;
        return (
            this.canWriteSettings && (
                <Button
                    color="secondary"
                    variant="contained"
                    component={RouterLink}
                    to={createPath(paths.contractsEdit, { id })}
                >
                    {t('common:edit')}
                </Button>
            )
        );
    };

    generateConfListItem = (payload: any): ViewEditCell[] => {
        const { t } = this.props;
        if (!payload) {
            return [];
        }

        const listItem: ViewEditCell[] = [
            {
                id: 'recurrence',
                title: t('communication.recurrence_conf.checkbox'),
                data: payload.group_policies?.recurring_enable,
                cellType: 'Boolean',
            },
            // {
            //     id: 'sms',
            //     title: t('communication.sms_conf.checkbox'),
            //     data: payload?.reservation_sms,
            //     cellType: 'Boolean',
            // },
            {
                id: 'autovalidate',
                title: t('communication.autovalidate_conf.checkbox'),
                hint: !this.isGroup ? t('communication.autovalidate_conf.hint_parent') : null,
                data: payload.group_policies?.skip_member_invitation,
                cellType: 'Boolean',
            },
        ];

        // fix key and activate when back ready
        // if (!this.isGroup) {
        //     listItem.push({
        //         id: 'pec',
        //         title: t('communication.pec.checkbox'),
        //         hint: t('communication.pec.hint_parent'),
        //         data: payload.group_policies?.pec,
        //         cellType: 'Boolean',
        //     });
        // }

        // LT-881 — Multigroupe, on the parent company only: the flag lives on
        // `lu_contract`, so a department has none of its own and activating it
        // here covers every group of the contract.
        //
        // `readOnly` once it is on, because the flag is one-way: id refuses the
        // on -> off transition until LT-1941 delivers the controlled
        // deactivation, which has to check that no rider of the contract still
        // holds a CORPORATE group elsewhere. An editable checkbox here would
        // offer an action whose only possible outcome is an error.
        //
        // Behind FEATURE_MULTIGROUP, like the Multigroupe user sheet.
        if (!this.isGroup && FEATURE_MULTIGROUP) {
            const multigroupEnabled = !!payload.multigroup_enabled;
            listItem.push({
                id: 'multigroup',
                title: t('communication.multigroup_conf.checkbox'),
                hint: multigroupEnabled
                    ? t('communication.multigroup_conf.hint_enabled')
                    : t('communication.multigroup_conf.hint_parent'),
                data: multigroupEnabled,
                cellType: 'Boolean',
                readOnly: multigroupEnabled,
            });
        }

        return listItem;
    };

    generatePaymentModeItems = (payload: CompanyNew, group: GroupPaymentPolicy): ViewEditCell[] => {
        const { t } = this.props;
        if (!payload) {
            return [];
        }

        const paymentOptions = payload.payment_settings?.contract_payment_policies;

        const now = new Date();
        const cards = payload.payment_settings?.payment_methods?.filter((pm) => pm.type.startsWith('card_'));
        const wireTransfers = payload.payment_settings?.payment_methods?.filter((pm) =>
            pm.type.startsWith('wire_transfer'),
        );
        const sepas = payload.payment_settings?.payment_methods?.filter((pm) => pm.type === 'sepa');
        const airplus = payload.payment_settings?.payment_methods?.filter((pm) => pm.type === 'airplus');

        // console.log({ cards, sepas, airplus });

        const paiementPolicyOptions: FormPickerDatas[] = paymentOptions?.allowed_modes?.map((m) => ({
            id: m,
            name: t(`paiement.${m}`),
        }));
        // [
        //     { id: 'centralized', name: t('paiement.central') },
        //     { id: 'individual', name: t('paiement.individual') },
        // ];

        const paiementOptions: FormPickerDatas[] = paymentOptions?.allowed_frequencies?.map((m) => ({
            id: m,
            name: t(`paiement.${m}`),
        }));
        // [
        //     { id: 'monthly', name: t('paiement.mensual') },
        //     { id: 'unitary', name: t('paiement.unitary') },
        // ];

        const paiementCardsOptions: FormPickerDatas[] = [
            ...(cards?.map((c) => ({
                ...c,
                name: `${t('paiement.cb_mask')} ${c.masked_number} (${c.name})`,
            })) || []),
        ];

        const paiementMensualOptions: FormPickerDatas[] = [
            ...paiementCardsOptions,
            // { id: 'wire_transfer', name: t('paiement.transfert') },
            ...(wireTransfers?.map((c) => ({
                ...c,
                name: `${t('paiement.transfert')}`,
            })) || []),
            { id: 'sepa', name: t('paiement.new_sepa') },
            ...(sepas?.map((c) => ({
                ...c,
                name: `${c.name} ${c.sepa_iban} - ${t('common:signed')}: ${DateUtils.tsToDate(
                    c.sepa_signature_date,
                    true,
                )}`,
            })) || []),
            { id: 'airplus', name: t('paiement.new_airplus') },
            ...(airplus?.map((c) => ({
                ...c,
                name: `${c.name} - ${t('common:exp')}: ${DateUtils.tsToDate(c.expiry_date, true)}`,
            })) || []),
        ];

        const groupPaymentSettings = payload.payment_settings?.group_payment_policies?.find(
            (gpp) => gpp.group_id === group.group_id,
        );
        // console.log({ payload, groupPaymentSettings, paiementPolicyOptions, paiementOptions, paiementMensualOptions });

        const listItem: ViewEditCell[] = [
            {
                id: 'centralized_payment',
                title: t('payment_policy'),
                data: groupPaymentSettings?.payment_mode,
                cellType: 'Picker',
                options: paiementPolicyOptions,
            },
            {
                id: 'centralized_payment_mode',
                title: t('centralized_payment_mode'),
                data: groupPaymentSettings?.payment_frequency,
                // hint: t('paiement.centralized_payment_mode_hint'),
                linked: [{ id: 'centralized_payment', value: 'centralized' }],
                cellType: 'Picker',
                options: paiementOptions,
            },
            {
                id: 'centralized_payment_mode',
                title: t('centralized_payment_mode'),
                data: groupPaymentSettings?.payment_frequency,
                linked: [{ id: 'centralized_payment', value: 'individual' }],
                cellType: 'Picker',
                options: paiementOptions?.filter((o) => o.id !== 'monthly'),
            },
            {
                id: 'centralized_mensual_payment_mode',
                title: t('centralized_mensual_payment_mode'),
                data: groupPaymentSettings?.default_payment_method?.id,
                linked: [
                    { id: 'centralized_payment', value: 'centralized' },
                    { id: 'centralized_payment_mode', value: 'unitary' },
                ],
                cellType: 'Picker',
                options: paiementCardsOptions,
            },
            {
                id: 'centralized_mensual_payment_mode',
                title: t('centralized_mensual_payment_mode'),
                data: groupPaymentSettings?.default_payment_method?.id,
                linked: [
                    { id: 'centralized_payment', value: 'centralized' },
                    { id: 'centralized_payment_mode', value: 'monthly' },
                ],
                cellType: 'Picker',
                options: paiementMensualOptions,
            },
            {
                id: 'airplus[card_number]',
                title: t('paiement.airplus_details.card_number'),
                data: '',
                placeholder: t('paiement.airplus_details.card_number_placeholder'),
                // hint: t('paiement.airplus_details.card_number_hint'),
                linked: [
                    { id: 'centralized_payment', value: 'centralized' },
                    { id: 'centralized_payment_mode', value: 'monthly' },
                    { id: 'centralized_mensual_payment_mode', value: 'airplus' },
                ],
                regex: /^[0-9]{15,16}$/,
            },
            {
                id: 'airplus[expiry_date]',
                title: t('paiement.airplus_details.expiration_date'),
                data: '',
                // data: DateUtils.dateFormat(payload.default_billing_month_payments?.expiry_date, 'yyyy-mm'),
                linked: [
                    { id: 'centralized_payment', value: 'centralized' },
                    { id: 'centralized_payment_mode', value: 'monthly' },
                    { id: 'centralized_mensual_payment_mode', value: 'airplus' },
                ],
                inputsAttributs: {
                    min: DateUtils.dateFormat(now, 'yyyy-mm'),
                    max: DateUtils.dateFormat(
                        DateUtils.getNextMonth(new Date(now.getFullYear() + 5, now.getMonth(), 1)),
                        'yyyy-mm',
                    ),
                    type: 'month',
                },
                // dateOutputFormat: 'yyyy-mm-dd',
            },
            {
                id: 'sepa[name]',
                title: t('paiement.sepa_details.name'),
                data: '',
                // defaultValue: formPayload.default_billing_month_payments?.sepa_holder_name || formPayload.name,
                linked: [
                    { id: 'centralized_payment', value: 'centralized' },
                    { id: 'centralized_payment_mode', value: 'monthly' },
                    { id: 'centralized_mensual_payment_mode', value: 'sepa' },
                ],
            },
            {
                id: 'sepa[iban]',
                title: t('paiement.sepa_details.iban'),
                data: '',
                // defaultValue: formPayload.default_billing_month_payments?.sepa_iban,
                placeholder: t('paiement.sepa_details.iban_placeholder'),
                hint: t('paiement.sepa_details.iban_hint'),
                linked: [
                    { id: 'centralized_payment', value: 'centralized' },
                    { id: 'centralized_payment_mode', value: 'monthly' },
                    { id: 'centralized_mensual_payment_mode', value: 'sepa' },
                ],
                regex: IBAN_REGEX,
                format: editIban,
            },
            {
                id: 'sepa[rum]',
                title: t('paiement.sepa_details.rum'),
                data: '',
                // defaultValue: formPayload.default_billing_month_payments?.sepa_rum,
                linked: [
                    { id: 'centralized_payment', value: 'centralized' },
                    { id: 'centralized_payment_mode', value: 'monthly' },
                    { id: 'centralized_mensual_payment_mode', value: 'sepa' },
                ],
            },
            {
                id: 'sepa[contract_signing_date]',
                title: t('paiement.sepa_details.contract_signing_date'),
                data: '',
                // defaultValue: formPayload.default_billing_month_payments?.sepa_signature_date,
                // disableTimestampConvertion: true,
                linked: [
                    { id: 'centralized_payment', value: 'centralized' },
                    { id: 'centralized_payment_mode', value: 'monthly' },
                    { id: 'centralized_mensual_payment_mode', value: 'sepa' },
                ],
                inputsAttributs: {
                    type: 'date',
                },
            },
            // {
            //     id: 'obp_webapp',
            //     title: t('obp_webapp'),
            //     type: 'boolean',
            //     linked: [{ id: 'centralized_payment', value: 'centralized' }],
            //     hint: t('obp_webapp_hint'),
            // },
        ];

        return listItem;
    };

    generateTabs = (payload: any): TabsDatas => {
        const { t } = this.props;
        const id = this.id;

        const isDepartment = this.isGroup;

        const tabs: TabsDatas = {
            loadAll: true,
            datas: [
                {
                    label: t('tabs.general'),
                    children: (
                        <>
                            <EnhancedListItem
                                datas={this.listItemBuilder(
                                    isDepartment
                                        ? (payload as unknown as GroupNew)
                                        : (payload as unknown as CompanyNew),
                                )}
                                title={t('common:form.general_infos')}
                                cardActions={
                                    <>
                                        {this.renderEditButton(id)}
                                        {/* {isDepartment && !payload.deletion_date && this.canWriteSettings && (
                                            <Dialog
                                                btnTitle={t('common:suspend')}
                                                description={`${t('common:suspendParam', {
                                                    id: payload.id,
                                                })} ${t('suspend_infos', {
                                                    dept: payload.name,
                                                    parent: payload.parent?.name,
                                                })}`}
                                                customButton={
                                                    <Button
                                                        size="small"
                                                        color="primary"
                                                        variant="contained"
                                                        aria-label="action"
                                                    >
                                                        {t('common:suspend')}
                                                    </Button>
                                                }
                                                onOK={(fields) =>
                                                    this.handleDeleteCompany(payload.id, payload.parent.id)
                                                }
                                            />
                                        )} */}
                                    </>
                                }
                            />
                            {/* <Comment entity={EntityName.COMPANIES} entityId={id} />
                            <br />
                            <Anchor id="contracts" />
                            <EnhancedTable
                                onRef={(ref) => (this.tableContractsRef = ref)}
                                title={t('contracts.title')}
                                headers={this.headerContractBuilder()}
                                type={this.tableRequestPoints.COMPANIES_CONTRACTS}
                                add={this.canWriteSettings && createPath(paths.companiesContractsAdd, { id })}
                            /> */}
                            {!!payload.history && <br />}
                            <ActionLogs history={payload.history} withValues />
                        </>
                    ),
                },
                {
                    label: t('groups'),
                    children: (
                        <>
                            <Anchor id="groups" />
                            <EnhancedTable
                                onRef={(ref) => (this.tableDepartmentsRef = ref)}
                                title={t('groups')}
                                headers={this.headerDepartmentBuilder()}
                                type={this.tableRequestPoints.COMPANIES_DEPARTMENTS}
                                // add={this.canWriteSettings && createPath(paths.companiesDepartmentsAdd, { id })}
                            />
                        </>
                    ),
                },
                {
                    label: t('memberships.title'),
                    children: (
                        <>
                            <Anchor id="memberships" />
                            <EnhancedTable
                                onRef={(ref) => (this.tableMembersRef = ref)}
                                title={t('memberships.title')}
                                headers={this.headerMembershipBuilder(payload)}
                                type={
                                    this.isGroup
                                        ? this.tableRequestPoints.GROUP_MEMBERSHIPS
                                        : this.tableRequestPoints.COMPANIES_MEMBERSHIPS
                                }
                                // add={this.canWriteSettings && createPath(paths.companiesMembershipsAdd, { id })}
                            />
                        </>
                    ),
                },
                // {
                //     label: t('tabs.pricing_billing'),
                //     children: (
                //         <>
                //             <EnhancedListItem
                //                 datas={this.listItemBillingBuilder(payload)}
                //                 title={t('billing_infos')}
                //                 cardActions={this.renderEditButton(id)}
                //             />
                //             <EnhancedListItem
                //                 datas={this.listItemPaiementBuilder(payload)}
                //                 title={t('paiement.title')}
                //                 cardActions={this.renderEditButton(id)}
                //             />
                //             {this.canReadPricing && !isDepartment && (
                //                 <EnhancedListItem
                //                     datas={this.listItemFacturationBuilder(payload)}
                //                     title={t('tarification')}
                //                 />
                //             )}
                //         </>
                //     ),
                // },
                {
                    label: t('tabs.communication'),
                    children: (
                        <>
                            <ViewEditBlock
                                title={t('parameters.title')}
                                nbColumn={3}
                                noActions={!this.canWriteSettings}
                                datas={this.generateConfListItem(payload)}
                                onSubmit={this.handleConfSubmit}
                            />
                            {/* LT-881 — no button of its own: the settings block opens it
                                through onRef when the submit turns Multigroupe on, and the
                                activation is only sent once it comes back OK. */}
                            <Dialog
                                onRef={(ref) => (this.multigroupDialogRef = ref)}
                                dialogTitle={t('communication.multigroup_conf.confirm_title')}
                                dialogTitleColor={DialogTextColor.RED}
                                description={t('communication.multigroup_conf.confirm_description')}
                                btnOKText={t('communication.multigroup_conf.confirm_ok')}
                                btnOKColor={DialogTextColor.RED}
                                btnKOText={t('common:cancel')}
                                onOK={this.handleMultigroupConfirm}
                                onKO={this.handleMultigroupCancel}
                                disableEscapeManual
                            />
                            <span style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                                {payload.payment_settings?.group_payment_policies?.map((group) => {
                                    return (
                                        <ViewEditBlock
                                            key={group.group_id}
                                            title={`${t('paiement.mode')} - ${group.group_name}`}
                                            nbColumn={1}
                                            noActions={!this.canWriteSettings}
                                            datas={this.generatePaymentModeItems(payload, group)}
                                            onSubmit={this.handlePaymentSubmit(group)}
                                            containerStyle={{ width: 'calc(50% - 4px)' }}
                                        />
                                    );
                                })}
                            </span>
                            {/* <FidForm company={payload} rightCheck={AccountRight.COMPANY_FID_PROGRAM} /> */}
                        </>
                    ),
                },
            ],
        };

        if (isDepartment) {
            tabs.datas.splice(1, 1);
        }
        return tabs;
    };

    isGroupNew(payload: Company | GroupNew): payload is GroupNew {
        return (payload as GroupNew).group !== undefined;
    }

    render() {
        const {
            t,
            globalClasses,
            getCompanyError,
            getTravelPoliciesError,
            getIndustriesError,
            getOrEditCompanyGroupPoliciesError,
            getOrEditContractGroupPoliciesError,
        } = this.props;
        const id = this.id;

        const error =
            getCompanyError ||
            getTravelPoliciesError ||
            getIndustriesError ||
            getOrEditCompanyGroupPoliciesError ||
            getOrEditContractGroupPoliciesError;

        const payload = this.isGroup ? this.group : this.company;

        const headerConf = payload
            ? this.isGroupNew(payload)
                ? {
                      title: payload.group?.name,
                      subtitle: `ID: ${payload.group?.id}`,
                  }
                : {
                      title: payload.name,
                      subtitle: `ID: ${payload.id}`,
                      bubble: payload.deletion_date ? { visible: true, text: t('common:suspended') } : undefined,
                  }
            : {};

        return (
            <App
                needRights={{ name: AccountRight.COMPANY_SETTINGS, mode: RightRank.R }}
                loading={!payload}
                loadingError={this.props.getContractError}
                onRetry={this.load}
                header={{
                    icon: 'default',
                    ...headerConf,
                    actions: this.getActions(id),
                    anchors: [
                        { href: '#general_infos', label: t('common:form.general_infos') },
                        {
                            href: '#additional_infos',
                            label: t('common:form.additional_infos'),
                        },
                        { href: '#documents', label: t('common:form.documents') },
                        { href: '#groups', label: t('groups') },
                        { href: '#memberships', label: t('memberships.title') },
                        { href: '#contracts', label: t('contracts.title') },
                        { href: '#history', label: t('common:history') },
                    ],
                }}
            >
                <ErrorMessage payload={error} />
                <ErrorMessage payload={this.props.contractViewActionsError} />
                {payload && (
                    <div className={globalClasses.blockShadowNew} style={{ flex: 1, overflow: 'hidden' }}>
                        <FastTabs tabs={this.generateTabs(payload)} />
                    </div>
                )}
            </App>
        );
    }
}

const CompanyViewPageWithStyleAndTranslation = withGlobalStyles(
    withStyles(styles)(withTranslation(['company', 'document', 'common'])(CompanyViewPage)),
);

const mapStateToProps = (state) => ({
    groups: companySelectors.getGroupsNew(state),
    companies: companySelectors.getCompaniesNew(state),
    dispatchGroups: driversSelectors.sortedDispatchGroup(state),
    getCompanyError: errorSelectors.getCompanyError(state),
    contractViewActionsError: errorSelectors.contractViewActionsError(state),
    getContractError: errorSelectors.getContractError(state),
    getIndustriesError: errorSelectors.getIndustriesError(state),
    getTravelPoliciesError: errorSelectors.getTravelPoliciesError(state),
    isLoadingTravelPolicy: pendingSelectors.isLoadingTravelPolicy(state),
    getOrEditCompanyGroupPoliciesError: errorSelectors.getOrEditCompanyGroupPoliciesError(state),
    getOrEditContractGroupPoliciesError: errorSelectors.getOrEditContractGroupPoliciesError(state),
});

const mapDispatchToProps = {
    clearError: errorActions.clearError,
    getCompany: companyActions.getCompanyNew,
    getCompanyReport: companyActions.getCompanyReport,
    exportCompanyTrips: companyActions.exportCompanyTrips,
    exportCompanyUsers: companyActions.exportCompanyUsers,
    editCompany: companyActions.editCompany,
    editCompanyDispatchGroups: companyActions.editCompanyDispatchGroups,
    deleteCompany: companyActions.deleteCompany,
    editMember: companyActions.editMember,
    deleteContract: companyActions.deleteContract,
    banDriverFromCompany: companyActions.banDriverFromCompany,
    unbanDriverFromCompany: companyActions.unbanDriverFromCompany,
    getTravelPolicies: companyActions.getTravelPolicies,
    getCompanyGroupPolicies: companyActions.getCompanyGroupPolicies,
    editCompanyGroupPolicies: companyActions.editCompanyGroupPolicies,
    setContractGroupsAutovalidate: companyActions.setContractGroupsAutovalidate,
    setContractMultigroup: companyActions.setContractMultigroup,

    getContractPaymentSettings: companyActions.getContractPaymentSettings,
    setGroupPaymentSettings: companyActions.setGroupPaymentSettings,
    createPaymentMethodSepa: companyActions.createPaymentMethodSepa,
    createPaymentMethodAirplus: companyActions.createPaymentMethodAirplus,

    getGroup: companyActions.getGroupNew,

    getDispatchGroups: driversActions.getDispatchGroups,

    getCompanyToPricingSets: pricingActions.getCompanyToPricingSets,
    deleteCompanyToPricingSets: pricingActions.deleteCompanyToPricingSets,
    getCompanyToExtras: pricingActions.getCompanyToExtras,
    createCompanyToExtras: pricingActions.createCompanyToExtras,
    deleteCompanyToExtras: pricingActions.deleteCompanyToExtras,
};

export default connect(mapStateToProps, mapDispatchToProps)(CompanyViewPageWithStyleAndTranslation);
